<template>
	<section>
		<Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
		<div class="container">
			<div class="jesuanhd">填写并核对订单信息</div>
			<Address @watchaddress="getCarlist"></Address>
			<div class="jiesuanbox">
				<div class="jstit">
					<span class="tit fl">支付方式</span>
				</div>
				<div class="selectgroup">
					<ul class="clearlist clearfix" v-if="query.jifen">
						<li class="active">
							<img src="/static/images/jifen.png" /> 积分支付
						</li>
						<li class>当前积分{{balance}}</li>
					</ul>
					<ul class="clearlist clearfix" v-else>
						<li :class="paymethod==2?'active':''" @click="changePayMethod(2)">
							<img src="/static/images/icon_alipay.png" /> 支付宝支付
						</li>
						<li :class="paymethod==1?'active':''" @click="changePayMethod(1)">
							<img src="/static/images/icon_wxpay.png" /> 微信支付
						</li>
						<li :class="paymethod==3?'active':''" @click="changePayMethod(3)">
							<img src="/static/images/shouxin.png" /> 授信支付
						</li>
					</ul>
				</div>
			</div>
			<div class="commonGoods">
				<div class="jiesuanbox">
					<div class="jstit">
						<span class="tit fl">确认订单信息</span>
					</div>
					<div class="cartcontent" v-for="(item,index) in carInfo.shoplist" :key="index">
						<table class="layui-table" lay-skin="line">
							<thead>
								<th>商品</th>
								<th>单价</th>
								<th>数量</th>
								<th>小计</th>
								<th>操作</th>
							</thead>
							<tbody class="tbList">
								<tr v-for="(item_i,index_i) in item.items" :key="index_i">
									<td>
										<a class="clearfix cpinfo" :href="'#/goodsdetail?id='+item_i.productid">
											<div class="img">
												<img :src="item_i.indexpic" />
											</div>
											<div class="cont">
												<div class="name">{{item_i.title}}</div>
												<div class="info">{{item_i.specname}}</div>
												<div class="color-red" v-if="item_i.showsign&&!item_i.issign">您选择产品属于非签约商品</div>
											</div>
										</a>
									</td>
									<td class="cart-price">
										<strong>{{query.jifen?'积分:':'￥'}}{{item_i.price}}</strong>
									</td>
									<td class="cart-numbers">
										<el-input-number v-model="item_i.num" :min="1" :max="1000" label size="mini" @change="changeNum(item_i)"></el-input-number>
									</td>
									<td class="cart-total">
										<strong class="color-red">{{query.jifen?'积分:':'￥'}}{{(item_i.price*item_i.num).toFixed(2)}}</strong>
									</td>
									<td class="cart-price">
										<el-button type="danger" size="small" @click="detele(item_i)">删除</el-button>
									</td>
								</tr>
							</tbody>
						</table>
						<el-select v-model="item.coupon" placeholder="请选择活动区域" @change="couponchange(item)">
							<el-option label="不使用优惠券" value></el-option>
							<el-option :label="counpitem.amount+'优惠券'" :value="counpitem.no" v-for="(counpitem) in item.couponlist" :key="counpitem.id"></el-option>
						</el-select>&nbsp;&nbsp;
						<span v-if="item.couponlist.length>0" class="color-primary">可用优惠券{{item.couponlist.length}}张</span>
						<span v-else>暂无可用优惠券</span>
					</div>
				</div>
				<div class="jiesuanbox" v-if="!query.jifen">
					<Invoice ref="invoice"></Invoice>
				</div>
				<div class="jiesuanbox">
					<div class="ordertotal">
						<div>
							<strong>{{carInfo.cartnum}}</strong>
							件商品,共计：{{query.jifen?'积分:':'￥'}}{{carInfo.total}}
						</div>
						<div v-if="!query.jifen" style="margin:10px 0;">运费：{{query.jifen?'积分:':'￥'}}{{carInfo.shipfee}}</div>
						<div v-if="couponmoney">优惠:{{couponmoney}}</div>
						<el-input placeholder="请输入备注" v-model="remark" clearable style="width:30%" maxlength="50"></el-input>
					</div>
				</div>
				<div class="jiesuanbox">
					<div class="text-right">
						合计：
						<span class="color-red" style="font-size: 18px; margin-right: 15px;">{{query.jifen?'积分:':'￥'}}{{(carInfo.amount-couponmoney).toFixed(2)}}</span>
						<a href="javascript:;" class="layui-btn layui-btn-lg primary_bg" @click="addOrder">提交订单</a>
					</div>
				</div>
			</div>
		</div>
		<Footer :indexData="indexData"></Footer>
	</section>
</template>
<script>
	import Header from "../components/header";
	import Footer from "../components/footer";
	import Address from "../components/address";
	import Invoice from "../components/invoice";
	layui.use(["layer"], function() {
		layer = layui.layer;
	});
	export default {
		components: {
			Header,
			Invoice,
			Footer,
			Address
		},
		name: "jiesuan",
		data() {
			return {
				balance: "",
				isinvoice: "1",
				invoiceid: "",
				submitorder: [], //订单信息列表
				guid: sessionStorage.guid,
				carInfo: {}, //购物车信息
				remark: "",
				counpList: "",
				couponmoney: 0.0,
				query: {},
				addressid: "",
				scekillgoods: {}, //秒杀商品详情
				paymethod: 2,
				indexData: {},
				userInfo: {},
				keyword: "",
				districtid: "",
				autotroph: sessionStorage.autotroph,
				isstaff:JSON.parse(sessionStorage.user).isstaff
			};
		},
		methods: {
			// 新增订单
			async addOrder() {
				if (!this.districtid) {
					layer.alert("请选择收货地址", {
						icon: 2
					});
					return;
				}

				let str_address = $('.adrlist .active .info').text().trim() + '，' + $('.adrlist .active .tel').text().trim()
				console.log(str_address)
				this.$confirm(str_address, '是否提交当前地址', {
					type: 'warning'
				}).then(async () => {
					let shoplist = this.carInfo.shoplist;
					let coupon = {};
					let res = "";
					if (this.query.jifen) {
						let body = Object.assign(this.query, {
							addressid: this.addressid,
							paymethod: this.paymethod,
						});
						res = await this.$fetch("member/submitordergift", {
							body
						});
						this.$router.push({
							path: `/usercenter?type3-2`
						});
					} else {
						this.submitorderprice(shoplist, coupon, res);
					}
				});


			},
			// 提交的订单数据
			async submitorderprice(shoplist, coupon, res) {
				this.invoiceid = "";
				let accountList = this.$refs.invoice.accountList;
				for (let i = 0; i < accountList.data.length; i++) {
					if (accountList.data[i].checked) {
						this.invoiceid = accountList.data[i].id;
					}
				}
				console.log(this.$refs.invoice.isinvoice, this.invoiceid);

				if (this.query.miaosha) {
					//秒杀商品
					let body = Object.assign(this.query, {
						addressid: this.addressid,
						paymethod: this.paymethod,
						remark: this.remark,
						coupon: shoplist[0].coupon,
						isinvoice: this.invoiceid != "" ? this.$refs.invoice.isinvoice : 0,
						invoiceid: this.invoiceid
					});
					res = await this.$fetch("member/submitorderdirect", {
						body
					});
				} else {
					//普通商品
					for (let i = 0; i < shoplist.length; i++) {
						coupon[shoplist[i].shopid] = shoplist[i].coupon;
						if (!coupon[shoplist[i].shopid]) {
							delete coupon[shoplist[i].shopid];
						}
					}
					res = await this.$fetch("Member/submitorder", {
						body: {
							remark: this.remark,
							coupon,
							addressid: this.addressid,
							paymethod: this.paymethod,
							isinvoice: this.invoiceid != "" ? this.$refs.invoice.isinvoice : 0,
							invoiceid: this.invoiceid,
							isdraft:this.isstaff==1?1:''
						}
					});
				}
				if (res) {
					
					if(this.isstaff==1){
						this.$router.push("/usercenter?type=1-0");
					}else{
						this.$router.push({
							path: `/jieguo?orderno=${res}&paymethod=${this.paymethod}`
						});
					}
				}
			},
			changePayMethod(type) {
				this.paymethod = type;
			},
			async changeNum(item) {
				console.log(item);
				let res = await this.$fetch("Cart/edit", {
					body: {
						productid: item.productid,
						num: item.num,
						specification: item.specification || '',
					}
				});
				if (res) {
					this.$message({
						message: "操作成功",
						type: "success"
					});
					this.getCarlist();
				}
			},
			// 删除
			async detele(item) {
				let {
					num,
					productid,
					specification
				} = item;
				let res = await this.$fetch("Cart/del", {
					body: {
						productid,
						specification
					}
				});
				this.$message.success("删除成功");
				this.getCarlist();
			},
			// 获取购物车列表
			async getCarlist(address) {
				if (address) {
					this.districtid = address.districtid;
					this.addressid = address.addressid;
				}
				let res = {};
				// 判断是来说秒杀商品还是普通商品
				if (this.query.miaosha) {
					let body = Object.assign(this.$route.query, {
						code: this.districtid
					});
					res = await this.$fetch("member/cartcheck", {
						body
					});
				} else if (this.query.jifen) {
					let body = Object.assign(this.$route.query, {
						code: this.districtid
					});
					res = await this.$fetch("member/giftcheck", {
						body
					});
				} else {
					// 获取 购物车选中的商品列表
					res = await this.$fetch("Cart/cartchecked", {
						body: {
							code: this.districtid,
							guid: this.guid
						}
					});
					// 把单价的字符串转number
					for (let i = 0; i < res.shoplist.length; i++) {
						for (let j = 0; j < res.shoplist[i].items.length; j++) {
							res.shoplist[i].items[j].price = parseFloat(
								res.shoplist[i].items[j].price
							);
						}
					}
				}
				let arr = [];
				for (let key in res.shoplist) {
					arr.push(res.shoplist[key]);
				}
				res.shoplist = arr;
				for (let i = 0; i < res.shoplist.length; i++) {
					res.shoplist[i]["coupon"] = "";
				}
				this.carInfo = res;
			},
			couponchange(item) {
				if (!item.coupon) {
					this.couponmoney = 0.0;
				} else {
					for (let i = 0; i < item.couponlist.length; i++) {
						if (item.couponlist[i].no == item.coupon) {
							this.couponmoney = parseFloat(item.couponlist[i].amount);
							break;
						}
					}
				}
			}
		},
		async mounted() {
			this.indexData = await this.$fetch("Index/indexdata");
			if (sessionStorage.user) {
				this.userInfo = JSON.parse(sessionStorage.user);
			}
			this.query = this.$route.query;
			this.getCarlist();
			if (this.query.jifen) {
				let res = await await this.$fetch("member/balance", {
					body: {
						type: "account2"
					}
				});
				console.log("积分数据", res);
				this.balance = res.balance;
			}
			$(".nav-service").hover(
				function() {
					$(this)
						.find(".downmenu")
						.slideDown("fast");
				},
				function() {
					$(this)
						.find(".downmenu")
						.stop()
						.slideUp("fast");
				}
			);

			$(".selectgroup li").on("click", function() {
				$(this)
					.addClass("active")
					.siblings()
					.removeClass("active");
			});
			$(".quanlist .quan").on("click", function() {
				$(this)
					.addClass("active")
					.siblings()
					.removeClass("active");
			});
		}
	};
</script>


<style lang='scss' scoped>
	.cartcontent {
		max-height: 900px;
		overflow-y: auto;
	}

	.topguanggao {
		width: 100%;
	}

	.el-carousel__item {
		height: 450px;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}

	.el-carousel__indicators {
		.el-carousel__indicator {
			margin-right: 10px !important;
		}
	}

	.isinvoice {
		width: 100%;
		text-align: left;
	}
</style>



// WEBPACK FOOTER //
// src/pages/jiesuan.vue